import { render, staticRenderFns } from "./TimeStamp.vue?vue&type=template&id=68ab7ff0&scoped=true"
import script from "./TimeStamp.vue?vue&type=script&lang=js"
export * from "./TimeStamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab7ff0",
  null
  
)

export default component.exports